import React from "react";

// KalamPrime Prism Play symbol — dual-chevron interlocked with a glowing play emblem.
export function NikLogo({ size = 34, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="nikG" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop stopColor="#38BDF8" />
            <stop offset="0.55" stopColor="#0066FF" />
            <stop offset="1" stopColor="#0047B3" />
          </linearGradient>
          <linearGradient id="nikGold" x1="18" y1="14" x2="34" y2="34" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFD666" />
            <stop offset="1" stopColor="#FFB800" />
          </linearGradient>
        </defs>
        <path d="M6 8 L20 24 L6 40 L13 40 L27 24 L13 8 Z" fill="url(#nikG)" />
        <path d="M22 14 L36 24 L22 34 Z" fill="url(#nikGold)" />
        <path d="M6 8 L20 24 L6 40" stroke="#38BDF8" strokeWidth="0.6" opacity="0.5" />
      </svg>
      {showText && (
        <span className="flex flex-col leading-none">
          <span className="font-display font-extrabold tracking-tight text-[0.95rem] leading-none whitespace-nowrap">
            <span className="text-white">KALAM</span>
            <span style={{ color: "var(--nik-blue)" }}>PRIME</span>
          </span>
          <span className="text-[9px] text-slate-400 tracking-wide mt-0.5">by Ishukart</span>
        </span>
      )}
    </div>
  );
}
